import { useState } from 'react';
import './App.css';
import ExcelUpload from './ExcelUpload';

// Previews every possible Prakriti report result (Single/Dual/Tridosha), generated by
// prakriti-source/generate.js from the actual page templates + content JSON (copied from
// JIVA-backend) — not a hand-ported reimplementation. Re-run `node generate.js` in
// prakriti-source/ after changing a template/content file to refresh these.
const COMBOS = [
  { key: 'vata', label: 'Vata (Single)' },
  { key: 'pitta', label: 'Pitta (Single)' },
  { key: 'kapha', label: 'Kapha (Single)' },
  { key: 'vata-pitta', label: 'Vata + Pitta (Dual)' },
  { key: 'vata-kapha', label: 'Vata + Kapha (Dual)' },
  { key: 'pitta-kapha', label: 'Pitta + Kapha (Dual)' },
  { key: 'tridosha', label: 'Balanced (Tridosha)' },
];

function App() {
  const [combo, setCombo] = useState('tridosha');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div style={{ padding: '10px 16px', background: '#2A2520', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ color: '#fff', fontWeight: 600, fontFamily: 'sans-serif' }}>Prakriti Report Preview:</span>
        <ExcelUpload />
        {COMBOS.map((c) => (
          <button
            key={c.key}
            onClick={() => setCombo(c.key)}
            style={{
              padding: '6px 12px',
              borderRadius: 6,
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'sans-serif',
              fontWeight: 600,
              background: combo === c.key ? '#BD4A1E' : '#fff',
              color: combo === c.key ? '#fff' : '#2A2520',
            }}
          >
            {c.label}
          </button>
        ))}
      </div>
      <iframe
        title="Prakriti Report Preview"
        src={`${process.env.PUBLIC_URL}/prakriti_report_${combo}.html`}
        style={{ flex: 1, border: 'none', display: 'block', width: '100%' }}
      />
    </div>
  );
}

export default App;
